export const toThousandSeparator = (currency: number): string | null => {
  if (currency === undefined || currency === null) {
    return null;
  }
  return String(currency).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
};
